import { OktaAuth } from "@okta/okta-auth-js"

const redirectUri = process.env.VUE_APP_OKTA_REDIRECT_URI || `${window.location.origin}/login/callback`
const postLogoutRedirectUri = process.env.VUE_APP_OKTA_POST_LOGOUT_REDIRECT_URI || window.location.origin
const scopes = (process.env.VUE_APP_OKTA_SCOPES || "openid profile email").split(" ")

const oktaAuth = new OktaAuth({
  issuer: process.env.VUE_APP_OKTA_ISSUER,
  clientId: process.env.VUE_APP_OKTA_CLIENT_ID,
  redirectUri,
  postLogoutRedirectUri,
  scopes,
  pkce: true,
})

export default oktaAuth
